import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faBan } from '@fortawesome/free-solid-svg-icons';

const MembersTable = ({ member, selectMember }) => {
  const { endpoint, membername, paused, penalty, queueName, ringinuse, stateInterface, wrapuptime, uniqueid } = member;

  return (
    <tr className='is-size-7 has-text-centered'>
      <td><input name="uniqueid" type="radio" onChange={ () => selectMember(uniqueid) }></input></td>
      <td>{ endpoint }</td>
      <td>{ membername }</td>
      <td>{ queueName }</td>
      <td>{ paused }</td>
      <td>{ penalty }</td>
      <td>{ ringinuse }</td>
      <td>{ stateInterface }</td>
      <td>{ wrapuptime }</td>
    </tr>
  )
}

// MembersTable.propTypes = {
//     data: PropTypes.string,
//     origem_primaria: PropTypes.string,
//     origem_secundaria: PropTypes.string,
//     setor: PropTypes.string,
//     destino_secundario: PropTypes.string,
//     destino_primario: PropTypes.string,
//     status: PropTypes.string,
//     aguardando_atendimento: PropTypes.string,
//     duracao: PropTypes.string,
//     tipo: PropTypes.string,
//     id: PropTypes.string,
//     sequencia: PropTypes.number,
//     protocolo: PropTypes.string,
//   };

export default MembersTable;

